import jsPDF from "jspdf";

// Original Hindi narration + the English translation Ranjana approved.
// English appears in the PDF (and the on-page transcript panel) — it is
// never displayed in the live audio captions.
const lines = [
  { hi: "Mai roz sochti hu Vandana…",                                                          en: "I think about it everyday Vandana…" },
  { hi: "Aakhir aisi kaunsi sidi hai jisse mai tum tak pahuch saku…",                          en: "What ladder I must climb to reach you…" },
  { hi: "Tumhe jalte aur tadapte dekh saku…",                                                  en: "The one that will let me watch you fall apart…" },
  { hi: "Mere iss battar Zindagi ka ek hi maksad hai…",                                        en: "My despicable life has a singular purpose…" },
  { hi: "Tumhe aise ghau du jo roz jale…",                                                     en: "To give you scars that will burn for life…" },
  { hi: "Jaise mere aur baakiyo ke…jinko tum bhool chuki…",                                    en: "The ones identical to mine and others…whom you've clearly forgotten…" },
  { hi: "Zakhm itne taaza aur gehre ho pui se bhare…ki jab jale toh tumhe humari yaad aaye…",  en: "Wounds so fresh and deep filled with pus…that they remind you of us…" },
  { hi: "",                                                                                    en: "" }, // separator
  { hi: "Phir mujhe khayal aata hai tumhare bete ka…",                                         en: "Then…I suddenly think about your son…" },
  { hi: "Usske naazuk aur komal jism ka…",                                                     en: "About his innocent and soft facade…" },
  { hi: "Tumhare darr ki…ek hi wajah ho sakti hai…",                                           en: "You might afterall, have a reason to fear…" },
  { hi: "Vandana…",                                                                            en: "Vandana…" },
];

export function downloadMonologueScript() {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();

  // Background — deep black
  doc.setFillColor(5, 5, 5);
  doc.rect(0, 0, pageW, pageH, "F");

  // Watermark — diagonal repeating
  doc.saveGraphicsState();
  doc.setGState(new doc.GState({ opacity: 0.07 }));
  doc.setTextColor(255, 255, 255);
  doc.setFont("times", "italic");
  doc.setFontSize(34);
  const wm = "© RANJANA SUMAN BARUAH";
  for (let y = 60; y < pageH + 200; y += 110) {
    for (let x = -80; x < pageW + 200; x += 270) {
      doc.text(wm, x, y, { angle: -28 });
    }
  }
  doc.restoreGraphicsState();

  // Header overlines
  doc.setTextColor(192, 21, 21);
  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.text("REEL 01 · NARRATION", 50, 50);

  doc.setTextColor(163, 163, 163);
  doc.text("FOR CASTING / PRODUCTION REFERENCE", pageW - 50, 50, {
    align: "right",
  });

  doc.setDrawColor(192, 21, 21);
  doc.setLineWidth(0.6);
  doc.line(50, 70, 130, 70);

  // Title
  doc.setTextColor(245, 245, 245);
  doc.setFont("times", "normal");
  doc.setFontSize(46);
  doc.text("Monologue", 50, 130);

  doc.setFont("times", "italic");
  doc.setTextColor(192, 21, 21);
  doc.setFontSize(32);
  doc.text("for Vandana.", 50, 170);

  // byline
  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.setTextColor(163, 163, 163);
  doc.text("WRITTEN & PERFORMED BY  ·  RANJANA SUMAN BARUAH", 50, 200);
  doc.text("HINDI ORIGINAL + ENGLISH TRANSLATION", 50, 215);

  // dotted divider
  doc.setLineDashPattern([1, 3], 0);
  doc.setDrawColor(255, 255, 255);
  doc.setLineWidth(0.5);
  doc.line(50, 240, pageW - 50, 240);
  doc.setLineDashPattern([], 0);

  // Two columns
  const colTop = 270;
  const colGap = 24;
  const colW = (pageW - 100 - colGap) / 2;
  const leftX = 50;
  const rightX = leftX + colW + colGap;

  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.setTextColor(163, 163, 163);
  doc.text("ORIGINAL · HINDI", leftX, colTop);
  doc.text("TRANSLATION · ENGLISH", rightX, colTop);

  doc.setFontSize(12);

  let y = colTop + 24;
  const lineH = 22;
  lines.forEach((c) => {
    if (c.hi === "") {
      doc.setFont("times", "normal");
      doc.setTextColor(192, 21, 21);
      doc.setFontSize(12);
      doc.text("· · · · ·", leftX + colW / 2, y, { align: "center" });
      doc.text("· · · · ·", rightX + colW / 2, y, { align: "center" });
      y += lineH;
      return;
    }
    doc.setFontSize(12);
    doc.setTextColor(245, 245, 245);

    doc.setFont("times", "italic");
    const hiLines = doc.splitTextToSize(c.hi, colW);
    doc.text(hiLines, leftX, y);

    doc.setFont("times", "normal");
    const enLines = doc.splitTextToSize(c.en, colW);
    doc.text(enLines, rightX, y);

    const used = Math.max(hiLines.length, enLines.length);
    y += lineH * used + 6;
  });

  // Footer
  doc.setLineDashPattern([1, 3], 0);
  doc.setDrawColor(255, 255, 255);
  doc.line(50, pageH - 70, pageW - 50, pageH - 70);
  doc.setLineDashPattern([], 0);

  doc.setFont("courier", "normal");
  doc.setFontSize(8);
  doc.setTextColor(163, 163, 163);
  doc.text("COPYRIGHT  ·  RANJANA SUMAN BARUAH", 50, pageH - 50);
  doc.text("WWW.RANJANABARUAH.COM", pageW - 50, pageH - 50, {
    align: "right",
  });
  doc.text(
    "All rights reserved. Reproduction, public performance, casting submission or AI-training use without written permission is prohibited.",
    pageW / 2,
    pageH - 30,
    { align: "center", maxWidth: pageW - 100 }
  );

  doc.save("Ranjana-Suman-Baruah-Monologue.pdf");
}
